import axios from '@_system/axios/axios.js'
export default {
	path: '/offer',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	copyBycode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/copyBycode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/offer.offer', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	listTrades(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/listTrades/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	setStatus(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/setStatus/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	cancontract(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/cancontract', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getTrackCode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getTrackCode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getDelivery(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getDelivery', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getconfigoptions(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getconfigoptions', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	push(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/push', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	close(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/close', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	import(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/import', data, (res) => {
				resolve(res.data)
			})
		})
	},






	print(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/print/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
